import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { notification } from "antd"
import { countNewProspects } from "store/slices/prospectSlice"
import { socket } from "."

const SocketManager = () => {
  const dispatch = useDispatch()
  const { data: user } = useSelector((state) => state.profile)

  useEffect(() => {
    if (!user?.id) return

    if (!socket.connected) {
      socket.connect()
    }

    socket.emit("registerPartner", user.id)
    console.log("Partner registered:", user.id)

    const handleNewProspect = (data) => {
      console.log("Nouveau prospect reçu:", data)

      notification.open({
        message: data.message,
        description: `${data.fullName} - ${data.need} (${data.carModel})`,
        placement: "topRight",
      })

      const audio = new Audio("/sounds/notication sound.wav")
      audio.play().catch(() => {})

      dispatch(countNewProspects())
    }

    socket.on("prospect:new", handleNewProspect)

    return () => {
      socket.off("prospect:new", handleNewProspect)
    }
  }, [user?.id])

  return null
}

export default SocketManager
